<template>
    <div class="integral-order-container">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-empty v-if="integralOrderList.length <= 0" description="没有产生过订单" />
            <van-list v-else :finished="finished" :error.sync="error" finished-text="没有更多了" @load="onLoad">
                <van-cell class="integral-order-item" v-for="(item, index) in integralOrderList" :key="index" @click="$router.push({ name : 'IntegralOrderDetail', query : { orderNo : item.order_no } })">
                    <van-row style="padding: 5px 10px;">
                        <van-col :span="18">{{item.order_no}}</van-col>
                        <van-col :span="6" style="text-align: right;color: #999;font-size: 14px;">{{$store.state.systemEnum['company']['user_integral_order']['status'][item.status]}}</van-col>
                    </van-row>
                    <div>
                        <van-card v-for="(goodsItem, goodsIndex) in item.detail.exchange_goods" :key="goodsIndex" :num="goodsItem.buy_number" :thumb="goodsItem.image">
                            <template #price>
                            <span class="base-theme-text" style="font-size:14px;">
								{{goodsItem.integral > 0 ? goodsItem.integral + '积分' : ''}}
								{{goodsItem.integral > 0 && goodsItem.amount > 0 ? '+' : ''}}
								{{goodsItem.amount > 0 ? goodsItem.amount + '元' : ''}}
                            </span>
                            </template>
                            <template #title>
                                <div style="font-size: 18px;">{{goodsItem.title}}</div>
                            </template>
                        </van-card>
                    </div>
                    <div class="integral-order-checkout">
                        <div class="integral-order-total">
                            总消费：
							<span class="base-theme-text">
								{{item.total_integral > 0 ? item.total_integral + '积分' : ''}}
								{{item.total_integral > 0 && item.total_amount > 0 ? '+' : ''}}
								{{item.total_amount > 0 ? item.total_amount + '元' : ''}}
							</span>
                        </div>
                    </div>
                </van-cell>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: 'IntegralOrder',
        data () {
            return {
                loading: false,
                finished: false,
                refreshing: false,
                error : false,
                params : {
                    page : 1,
                    page_size : 15,
                },
                integralOrderList : [],
            };
        },
        created() {
            this.onRefresh();
        },
        methods : {
            onLoad(){
                let self = this;
                if(self.loading) return;

                self.loading = true;
                api.request('/integral_order/list', Object.assign({}, self.params)).then(res => {
                    if(self.params.page >= res.data.max_page){
                        self.finished = true;
                    }else{
                        self.params.page++;
                    }

                    // 如果是刷新就把数据清空
                    if(self.refreshing){
                        self.integralOrderList = [];
                    }

                    for(let index in res.data.data){
                        self.integralOrderList.push(res.data.data[index]);
                    }
                }).catch(res => {
                    self.error = true;
                }).finally(() => {
                    self.loading = false;
                    self.refreshing = false;
                });
            },
            onRefresh() {
                this.finished = false;
                this.refreshing = true;
                this.params.page = 1;
                this.onLoad();
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    .integral-order-container {
        padding: 10px;

        .integral-order-item{
            border: 1px solid #eeeeee;
            border-radius: 10px;
            padding: 0;
            margin-bottom: 10px;

            .integral-order-checkout {
                display: flex;
                justify-content: flex-end;
                font-size: 14px;
                padding: 10px 0;

                .integral-order-total{
                    margin-right: 10px;
                    color: #969799;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/order/IntegralOrder.vue